var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "warp" },
    [
      _c(
        "el-form",
        { key: _vm.keyInvoice, attrs: { "label-width": "auto" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-descriptions",
                { attrs: { colon: false, column: 3, direction: "vertical" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.signedPhoto") } },
                    [
                      _c("sensitive-images", {
                        attrs: {
                          "field-name": "reverseSignedNamePhoto",
                          "encrypted-value":
                            _vm.tableInfomation.reverseSignedNamePhoto,
                          label: _vm.$t("GlobalSetObj.signedPhoto"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: _vm.$t("GlobalSetObj.signedNamePhoto"),
                        span: 2,
                      },
                    },
                    [
                      _c("sensitive-images", {
                        attrs: {
                          "field-name": "reverseSignedPhoto",
                          "encrypted-value":
                            _vm.tableInfomation.reverseSignedPhoto,
                          label: _vm.$t("GlobalSetObj.signedNamePhoto"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.TypeRecipient") } },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.tableInfomation.reverseSignTypeName)),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.SignerName") } },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "reverseDeliverySigner",
                          "encrypted-value":
                            _vm.tableInfomation.reverseDeliverySigner,
                          label: "reverseDeliverySigner",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.RecipientDOC") } },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "reverseSignDocument",
                          "encrypted-value":
                            _vm.tableInfomation.reverseSignDocument,
                          label: "reverseSignDocument",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: _vm.$t("GlobalSetObj.SigningTime"),
                        span: 3,
                      },
                    },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.tableInfomation.reverseDeliveredTime || "--"
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }